import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { configure } from "mobx";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { ApiConnector } from "../api/api-connector";
import { queryClient } from "../api/query-client";
import { TooltipProvider } from "../components/ui-kit/base/tooltip";
import { DialogProvider } from "../components/ui-kit/dialog-provider";
import { ToastsProvider } from "../components/ui-kit/toasts";
import { apiRoute } from "../config/config";
import { getInitialLocale, setLocale } from "../i18n.react";
import { AppModel } from "./app-model";
import { initGlobalErrorHandling } from "./errors";
import { createRouter } from "./router";
import { initSentry } from "./sentry";

configure({ enforceActions: "never" });

async function main() {
  initSentry();
  initGlobalErrorHandling();

  await setLocale(getInitialLocale());

  const seerlinqApi = new ApiConnector(apiRoute);
  seerlinqApi.init();

  const app = new AppModel(seerlinqApi);
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    throw new Error("Root element not found");
  }

  const router = createRouter(app);
  const root = createRoot(rootElement);
  root.render(
    <I18nProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <ToastsProvider>
            <DialogProvider>
              <RouterProvider router={router} />
            </DialogProvider>
          </ToastsProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </I18nProvider>,
  );

  app.init();
}

void main();
